import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../Polyline.js";
import n from "../SpatialReference.js";
import { isPolygon as t } from "./jsonUtils.js";
var r = {
  102100: {
    maxX: 20037508.342788905,
    minX: -20037508.342788905,
    plus180Line: new e({
      paths: [[[20037508.342788905, -20037508.342788905], [20037508.342788905, 20037508.342788905]]],
      spatialReference: n.WebMercator
    }),
    minus180Line: new e({
      paths: [[[-20037508.342788905, -20037508.342788905], [-20037508.342788905, 20037508.342788905]]],
      spatialReference: n.WebMercator
    })
  },
  4326: {
    maxX: 180,
    minX: -180,
    plus180Line: new e({
      paths: [[[180, -180], [180, 180]]],
      spatialReference: n.WGS84
    }),
    minus180Line: new e({
      paths: [[[-180, -180], [-180, 180]]],
      spatialReference: n.WGS84
    })
  }
};

function i(e, n) {
  return Math.ceil((e - n) / (2 * n));
}

function o(e, n) {
  var t = s(e);

  var _iterator = _createForOfIteratorHelper(t),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;

      var _iterator2 = _createForOfIteratorHelper(_r),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e = _step2.value;
          _e[0] += n;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return e;
}

function s(e) {
  return t(e) ? e.rings : e.paths;
}

function a(e) {
  var n = (null == e ? void 0 : e.isWebMercator) ? 102100 : 4326;
  return [r[n].minX, r[n].maxX];
}

export { r as cutParams, s as getGeometryParts, a as getSpatialReferenceMinMaxX, i as offsetMagnitude, o as updatePolyGeometry };